/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RenameCustomFieldRequest
 */
export interface RenameCustomFieldRequest {
    /**
     * 
     * @type {string}
     * @memberof RenameCustomFieldRequest
     */
    name: string;
}

export function RenameCustomFieldRequestFromJSON(json: any): RenameCustomFieldRequest {
    return RenameCustomFieldRequestFromJSONTyped(json, false);
}

export function RenameCustomFieldRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenameCustomFieldRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function RenameCustomFieldRequestToJSON(value?: RenameCustomFieldRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}


